import { useUtils } from "@/app/hooks/useUtils";
import clsx from "clsx";

const SubServiceName: React.FC<{ subServiceId: string; serviceId: string; className?: string }> = (props) => {
  const { getSubService } = useUtils();
  const subService = getSubService(props?.serviceId, props?.subServiceId);

  return <span className={clsx(props?.className)}>{subService?.sub_service_name ?? "No Sub Service"}</span>;
};
export default SubServiceName;
